module.exports = __webpack_public_path__ + "static/media/metervibe_app_desktop_1.764586aa.png";